export default __webpack_public_path__ + "static/header.alupress.uebersicht-0338a60b6fdc516304e46c1e1224be2b.png";